import React from "react";

class SelectMenu extends React.Component {
  getSelectedOption() {
    return this.refs.selected_option.value;
  }

  renderSelect() {
    let nodes = this.props.options.map((item, idx) => (
      <option key={idx} value={item[0]}>
        {item[1]}
      </option>
    ));

    return (
      <select
        className="form-control select"
        ref="selected_option"
        defaultValue={this.props.value}
        disabled={this.props.disabled}
        onChange={this.props.onChange}
        required={this.props.required}
      >
        {this.props.placeholder && (
          <option value="">{this.props.placeholder}</option>
        )}
        {nodes}
      </select>
    );
  }

  render() {
    return (
      <div
        className={
          this.props.error ? "form-group select has-error" : "form-group select"
        }
      >
        <label className="control-label selectop">{this.props.label}</label>{" "}
        <br />
        {this.renderSelect()}
        {this.props.error && (
          <span className="help-block">{this.props.error}</span>
        )}
      </div>
    );
  }
}

export default SelectMenu;
